module.exports = __webpack_public_path__ + "img/slide03.1d7260de.jpg";